<span [ngSwitch]="priority.code">
  <span class="badge_state danger" *ngSwitchCase="priorityEnum.High">
    {{'general.highPriority' | translate}}
  </span>
  <span class="badge_state orange" *ngSwitchCase="priorityEnum.Medium">
    {{'general.mediumPriority' | translate}}
  </span>
  <span class="badge_state success" *ngSwitchCase="priorityEnum.Low">
    {{'general.lowPriority' | translate}}
  </span>
</span>
